<template>
  <el-table
    ref="evalTable"
    :data="data"
    :border="true"
    class="sk-table"
    style="width: 100%"
    v-loading="loading"
    @selection-change="handleSelectionChange"
  >
    <!-- Checkbox chọn row -->
    <el-table-column type="selection" width="45" align="center" />

    <!-- STT -->
    <el-table-column label="STT" type="index" width="50" align="center" />

    <!-- Tên học sinh -->
    <el-table-column label="Tên học sinh" prop="studentName" min-width="160">
      <template slot-scope="{ row }">
        <span class="evl-student-name">{{ row.studentName }}</span>
      </template>
    </el-table-column>

<!--    &lt;!&ndash; Danh mục &ndash;&gt;-->
<!--    <el-table-column v-if="activeTab === 'DAILY'" label="Danh mục" width="120" align="center">-->
<!--      <template slot-scope="{ row }">-->
<!--        <template v-if="row.evaluations && row.evaluations.length > 0">-->
<!--          <el-tag-->
<!--            v-for="evaluation in row.evaluations"-->
<!--            :key="evaluation.uid + '_cat'"-->
<!--            size="mini"-->
<!--            :type="categoryTagType(evaluation.category)"-->
<!--            style="margin: 2px"-->
<!--          >-->
<!--            {{ categoryLabel(evaluation.category) }}-->
<!--          </el-tag>-->
<!--        </template>-->
<!--        <span v-else class="text-slate-400">—</span>-->
<!--      </template>-->
<!--    </el-table-column>-->

    <!-- Ngày tạo -->
    <el-table-column label="Ngày tạo" width="150" align="center">
      <template slot-scope="{ row }">
        <template v-if="row.evaluations && row.evaluations.length > 0">
          <div v-for="evaluation in row.evaluations" :key="evaluation.uid + '_date'" class="evl-date-cell">
            <span>{{ evaluation.createdDate | formatDateTime }}</span>
          </div>
        </template>
        <span v-else class="text-slate-400">—</span>
      </template>
    </el-table-column>

    <!-- Duyệt -->
    <el-table-column label="Duyệt" width="100" align="center">
      <template slot-scope="{ row }">
        <template v-if="row.evaluations && row.evaluations.length > 0">
          <el-tag
              size="mini"
              :type="getApprovalStatus(row) === 'APPROVED' ? 'success' : 'info'"
          >
            {{ getApprovalStatus(row) === 'APPROVED' ? 'Đã duyệt' : 'Chờ duyệt' }}
          </el-tag>
        </template>
        <span v-else class="text-slate-400">—</span>
      </template>
    </el-table-column>

    <!-- Nhận xét (chỉ nội dung) -->
    <el-table-column label="Nhận xét" min-width="300">
      <template slot-scope="{ row }">
        <div v-if="row.evaluations && row.evaluations.length > 0">
          <div
            v-for="(evaluation, idx) in row.evaluations"
            :key="evaluation.uid"
            class="evl-evaluation-item"
            :class="{ 'evl-evaluation-item--border': idx > 0 }"
          >
            <!-- Daily mới: chỉ hiển thị danh mục (tag) -->
            <template v-if="evaluation.items && evaluation.items.length > 0">
              <div class="evl-item-tags">
                <el-tag
                  v-for="item in evaluation.items"
                  :key="item.categoryId"
                  size="mini"
                  style="margin: 2px"
                >
                  {{ item.categoryName }}
                </el-tag>
              </div>
            </template>
            <!-- Weekly/Monthly hoặc daily cũ: hiển thị content -->
            <template v-else>
              <div :class="['evl-eval-content', { expanded: isExpanded(row.studentId, evaluation.uid) }]">
                <span>{{ evaluation.content }}</span>
              </div>
              <div v-if="showToggle(evaluation.content)" class="evl-desc-toggle">
                <a href="#" @click.prevent="toggleExpand(row.studentId, evaluation.uid)">
                  {{ isExpanded(row.studentId, evaluation.uid) ? 'Thu gọn' : 'Xem thêm' }}
                </a>
              </div>
            </template>
          </div>
        </div>
        <span v-else class="text-slate-400">—</span>
      </template>
    </el-table-column>

    <!-- File/ảnh đính kèm -->
    <el-table-column label="File" width="80" align="center">
      <template slot-scope="{ row }">
        <template v-if="row.evaluations && row.evaluations.length > 0">
          <div v-for="evaluation in row.evaluations" :key="evaluation.uid + '_files'" class="evl-file-cell">
            <span v-if="getFileCount(evaluation) > 0" class="evl-file-count">
              <a href="#" @click.prevent="$emit('view-files', evaluation.files)">
                <i class="el-icon-paperclip" /> {{ getFileCount(evaluation) }}
              </a>
            </span>
            <span v-else class="text-slate-400">—</span>
          </div>
        </template>
        <span v-else class="text-slate-400">—</span>
      </template>
    </el-table-column>

    <!-- Phản hồi -->
    <el-table-column label="Phản hồi" width="100" align="center">
      <template slot-scope="{ row }">
        <template v-if="row.evaluations && row.evaluations.length > 0">
          <span class="evl-reply-badge" :class="{ 'evl-reply-badge--active': getTotalReplies(row) > 0 }">
            <i class="el-icon-chat-dot-round" /> {{ getTotalReplies(row) }}
          </span>
        </template>
        <span v-else class="text-slate-400">—</span>
      </template>
    </el-table-column>

    <!-- Thao tác -->
    <el-table-column label="Thao tác" width="230" align="center" fixed="right">
      <template slot-scope="{ row }">
        <div v-if="row.evaluations && row.evaluations.length > 0" class="flex flex-wrap justify-center gap-1">
          <el-tooltip content="Xem chi tiết" placement="top">
            <el-button
              type="primary"
              icon="el-icon-view"
              size="mini"
              circle
              plain
              @click="$emit('view', row)"
            />
          </el-tooltip>
          <el-tooltip content="Chỉnh sửa" placement="top">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              circle
              plain
              @click="handleEditFirst(row)"
            />
          </el-tooltip>
          <el-tooltip content="Duyệt" placement="top">
            <el-button
              type="success"
              icon="el-icon-check"
              size="mini"
              circle
              plain
              :disabled="getApprovalStatus(row) === 'APPROVED'"
              @click="handleApproveFirst(row)"
            />
          </el-tooltip>
          <el-tooltip content="Lịch sử" placement="top">
            <el-button
              type="info"
              icon="el-icon-time"
              size="mini"
              circle
              plain
              @click="handleActivityLog(row)"
            />
          </el-tooltip>
          <el-tooltip content="Xóa" placement="top">
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              circle
              plain
              @click="handleDeleteFirst(row)"
            />
          </el-tooltip>
        </div>
        <div v-else class="flex flex-wrap justify-center gap-1">
          <el-tooltip content="Thêm nhận xét" placement="top">
            <el-button
                type="primary"
                icon="el-icon-plus"
                size="mini"
                circle
                plain
                @click="$emit('add-for-student', row)"
            />
          </el-tooltip>

          <el-tooltip content="Lịch sử" placement="top">
            <el-button
                type="info"
                icon="el-icon-time"
                size="mini"
                circle
                plain
                @click="handleActivityLog(row)"
            />
          </el-tooltip>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>

export default {
  name: "EvaluationTable",
  props: {
    data: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    activeTab: { type: String, default: "DAILY" },
  },
  data() {
    return {
      expandedIds: [], // Array of "studentId_uid"
    };
  },
  filters: {
    formatDate(val) {
      if (!val) return "";
      const parts = val.split("-");
      if (parts.length === 3) return `${parts[2]}/${parts[1]}`;
      return val;
    },
  },
  methods: {
    getExpandKey(studentId, uid) {
      return `${studentId}_${uid}`;
    },
    isExpanded(studentId, uid) {
      return this.expandedIds.includes(this.getExpandKey(studentId, uid));
    },
    toggleExpand(studentId, uid) {
      const key = this.getExpandKey(studentId, uid);
      const idx = this.expandedIds.indexOf(key);
      if (idx === -1) this.expandedIds.push(key);
      else this.expandedIds.splice(idx, 1);
    },
    showToggle(content) {
      return content && String(content).length > 80;
    },
    handleEditFirst(row) {
      if (row.evaluations && row.evaluations.length > 0) {
        this.$emit("edit", { studentId: row.studentId, studentName: row.studentName, evaluation: row.evaluations[0] });
      }
    },
    handleDeleteFirst(row) {
      if (row.evaluations && row.evaluations.length > 0) {
        this.$emit("delete", { studentId: row.studentId, studentName: row.studentName, evaluation: row.evaluations[0] });
      }
    },
    handleApproveFirst(row) {
      if (row.evaluations && row.evaluations.length > 0) {
        this.$emit("approve", { studentId: row.studentId, studentName: row.studentName, evaluation: row.evaluations[0] });
      }
    },
    handleActivityLog(row) {
      this.$emit("activity-log", { studentId: row.studentId, studentName: row.studentName, evaluation: row.evaluations ? row.evaluations[0] : null });
    },
    getApprovalStatus(row) {
      if (!row.evaluations || row.evaluations.length === 0) return "";
      // Nếu tất cả đều APPROVED thì trả APPROVED, ngược lại PENDING
      const allApproved = row.evaluations.every(ev => ev.approved !== false);
      return allApproved ? "APPROVED" : "PENDING";
    },
    handleSelectionChange(selection) {
      this.$emit("selection-change", selection);
    },
    getTotalReplies(row) {
      if (!row.evaluations || row.evaluations.length === 0) return 0;
      return row.evaluations.reduce((sum, ev) => {
        return sum + ((ev.replies && ev.replies.length) || 0);
      }, 0);
    },
    getFileCount(evaluation) {
      return Array.isArray(evaluation && evaluation.files) ? evaluation.files.length : 0;
    },
    clearSelection() {
      this.$refs.evalTable?.clearSelection();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-table";

/deep/ .el-table .el-table__row td {
  vertical-align: middle;
}

.evl-student-name {
  font-weight: 600;
  color: #1e293b;
}

.evl-evaluation-item {
  padding: 0;
}
.evl-evaluation-item--border {
  border-top: 1px dashed #e2e8f0;
  margin-top: 4px;
  padding-top: 6px;
}

.evl-item-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.evl-date-cell {
  font-size: 13px;
  color: #475569;
  padding: 2px 0;
}

.evl-file-cell {
  padding: 2px 0;
}

.evl-file-count {
  color: #2563eb;
  font-weight: 600;
}

.evl-eval-content {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-line;
  font-size: 13px;
  color: #1e293b;
  line-height: 1.5;
}
.evl-eval-content.expanded {
  -webkit-line-clamp: unset;
  overflow: visible;
}

.evl-desc-toggle {
  margin-top: 4px;
  a { color: #2563eb; cursor: pointer; font-size: 12px; }
}

.evl-eval-footer {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 6px;
}
.evl-teacher {
  font-size: 12px;
  color: #64748b;
  font-style: italic;
}
.evl-reply-count {
  font-size: 12px;
  color: #2563eb;
  font-weight: 600;
  i { margin-right: 2px; }
}

.evl-reply-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #94a3b8;
  font-weight: 500;
  i { font-size: 14px; }
}
.evl-reply-badge--active {
  color: #2563eb;
  font-weight: 600;
}
</style>
